import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to the top on every route change (SPA navigation keeps the previous
// scroll position otherwise). Renders nothing; must live inside <BrowserRouter>.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
